import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { AmountFormatCell, DateFormatCell } from "components/common/formatter";
import { useEffect } from "react";
import { NameTextCell } from "components/common/GridComponents";
import { Checkbox } from "@progress/kendo-react-inputs";
import { getMatterDisbRecords } from "api";
import QuickPostings from "components/QuickPosting";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const MattersDisbRecords = (props) => {
  const [data, setData] = React.useState([]);
  const [addDisbursement, setAddDisbursement] = React.useState(false);
  const [error, setError] = React.useState(false);
  const AmountNameHeader = (props) => {
    return (
      <div style={{ textAlign: "center", marginBottom: "8px" }}>{props.title}</div>
    );
  };

  const handleSubmit = () => {
    if (getSelectedItemsCount() === 0) {
      setError(true);
      return;
    }

    let dataToPost = [];
    data.map((item) => {
      if (item.add === true) {
        dataToPost.push(item);
      }
    });
    props.changeMatterDisbList(dataToPost);
    props.cancelEdit();
  };
  const itemChange = (e) => {
    let newData = data.map((item) => {
      if (item.postingId === e.dataItem.postingId) {
        item.add = e.value;
      }
      return item;
    });
    setData(newData);
  };

  const getMatterDisbursementRecords = async (matterId, transactionNo) => {
    try {
      const dataResponse = await getMatterDisbRecords(matterId);
      const existingPostingIds = (props.existingRecords || []).map(
        (record) => record.postingId,
      );
      const filteredRecords = (dataResponse.data?.data || []).filter(
        (record) => !existingPostingIds.includes(record.postingId),
      );

      setData(
        filteredRecords.map((item) => ({
          ...item,
          inEdit: true,
          billVat: 0,
          vatCode: item.vatCode || 0,
          add: item.transactionNo === transactionNo || false,
        })),
      );
    } catch (error) {}
  };

  useEffect(() => {
    getMatterDisbursementRecords(props?.matter?.matterId);
  }, []);

  const SelectionHeaderCell = (props) => {
    return (
      <div className="gap-2 mb-2 d-flex">
        <span>{props.title}</span>
        <Checkbox
          style={{
            width: "18px",
            height: "18px",
            boxShadow: "0px 0px 16px rgba(0, 0, 0, 0.1)",
          }}
          onChange={(e) => {
            if (e.value) {
              setData((prevData) =>
                prevData.map((item) => ({ ...item, add: true })),
              );
            } else {
              setData((prevData) =>
                prevData.map((item) => ({ ...item, add: false })),
              );
            }
          }}
          name="isCounselFee"
          disabled={data.length === 0}
          value={data.filter((item) => !item.add).length === 0}
        />
      </div>
    );
  };
  const getSelectedItemsCount = () => {
    return data.filter((item) => item.add === true).length;
  };
  const hasRecords = data.length > 0;

  return (
    <Dialog
      title={`Disbursement Records for Matter`}
      onClose={props.cancelEdit}
      className="dialog-xl">
      <div
        className="d-flex flex-column h-100 overflow-hidden"
        style={{ minHeight: 0 }}>
        <div className="flex-shrink-0 d-flex flex-column pt-2 px-5">
          <Button
            className="common-btn mt-1 mb-1"
            style={{ alignSelf: "flex-end" }}
            onClick={() => setAddDisbursement(true)}>
            {" "}
            + New Disbursement
          </Button>
        </div>

        <div
          className="flex-grow-1 d-flex flex-column px-5 pb-3"
          style={{ minHeight: 0 }}>
          <Grid
            data={data}
            dataItemKey={"postingId"}
            onItemChange={itemChange}
            editField="inEdit"
            className="grid-header-sm mt-1"
            style={{ height: "100%", minHeight: 0 }}>
            <Column
              field="postingType"
              title="Type"
              headerClassName="ps-4"
              className="ps-3"
              editable={false}
              width="80px"
            />

            <Column field="date" title="Date" width="110px" cell={DateFormatCell} />
            <Column
              field="details"
              title="Details"
              editable={false}
              cell={NameTextCell}
            />
            <Column field="feeEarnerRef" title="FE" editable={false} width="80px" />

            <Column
              field="vatAmount"
              title="Vat"
              editable={false}
              cell={AmountFormatCell}
              headerCell={AmountNameHeader}
              width="80px"
            />

            <Column
              field="netAmount"
              title="Net"
              editable={false}
              cell={AmountFormatCell}
              headerCell={AmountNameHeader}
              width="100px"
            />

            <Column
              field="add"
              title="Select"
              className="d-flex align-items-center justify-center mt-2 ms-3"
              editor="boolean"
              editable={hasRecords}
              width={"90px"}
              headerCell={SelectionHeaderCell}
            />
          </Grid>
          {error === true && getSelectedItemsCount() === 0 && data.length > 0 && (
            <i style={{ color: "red" }}>Select atleast 1 Record</i>
          )}
        </div>
      </div>

      <DialogActionsBar>
        <div className="dialog-footer w-100">
          <button
            type="button"
            className="common-btn bgBtnSecondary border-0 me-3"
            onClick={() => {
              props.cancelEdit();
            }}>
            Cancel
          </button>
          <SubmitButton
            type="submit"
            className="me-4"
            disabled={!hasRecords}
            onClick={handleSubmit}>
            Add to Bill
          </SubmitButton>
        </div>
      </DialogActionsBar>
      {addDisbursement && (
        <QuickPostings
          onClose={() => setAddDisbursement(false)}
          postingCode={"DUU"}
          defaultMatter={props.matter}
          onSubmit={(response) =>
            getMatterDisbursementRecords(
              props?.matter?.matterId,
              response.transactionNo,
            )
          }
        />
      )}
    </Dialog>
  );
};

export default MattersDisbRecords;
